import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiOfficerAddUserPermissionDefinition from "./taxi-officer-add-user-permission";

const useTaxiOfficerAddUserPermissions = () => {
  return useUserPermissions(taxiOfficerAddUserPermissionDefinition);
};

export default useTaxiOfficerAddUserPermissions;
